/* eslint-disable indent */
import { TopLevelSpec as VegaLiteSpec } from 'vega-lite';
import { UnitSpec } from 'vega-lite/build/src/spec';
import { liteBaseConfig } from '../vegaShared';

export interface ISparklineOptions {
  data: any[];
  xField: string;
  xFieldType: 'ordinal' | 'temporal'; // Added xFieldType option
  yField: string;
  color?: string;
  width?: number | 'container';
  height?: number | 'container';
  yMin?: number;
  yMax?: number;
}

export const genSparklineSpec = (options: ISparklineOptions): VegaLiteSpec => {
  const color = options.color || '#3c5ccf';

  const lineLayer: UnitSpec = {
    mark: {
      type: 'line',
      color,
      interpolate: 'monotone',
      yOffset: -1,
    },
  };

  const areaLayer: UnitSpec = {
    mark: {
      type: 'area',
      fill: {
        gradient: 'linear',
        x1: 1,
        x2: 1,
        y1: 1,
        y2: 0,
        stops: [
          { offset: 0, color: 'white' },
          { offset: 1, color },
        ],
      },
      interpolate: 'monotone',
    },
  };

  const config = {
    ...liteBaseConfig(),
    axis: {
      labels: false,
      title: false,
      domain: false,
      ticks: false,
    },
  };

  const baseSpec: VegaLiteSpec = {
    $schema: 'https://vega.github.io/schema/vega-lite/v4.json',
    autosize: 'fit',
    width: options.width || 'container',
    height: options.height || 100,
    // @ts-ignore
    config,
    encoding: {
      x: { field: options.xField, type: options.xFieldType || 'ordinal', axis: null }, // Use xFieldType option
      y: {
        field: options.yField,
        type: 'quantitative',
        axis: null,
        scale: { padding: 2, ...(options.yMax && { domain: [options.yMin || 0, options.yMax] }) },
      },
    },
    layer: [areaLayer, lineLayer], // Draw the area layer first so the line layer appears on top
    data: { values: options.data },
  };
  return baseSpec;
};
